/** @format */
import { FilterOption } from '@toucan/client/features/search/config/types';

export function isSelected(
    option: FilterOption,
    selectedOptions: FilterOption[]
): boolean {
    return selectedOptions.some((selectedOption) => {
        return selectedOption.value === option.value;
    });
}

export function unSelectItem(
    item: FilterOption,
    selectedOptions: FilterOption[]
): FilterOption[] {
    return selectedOptions.filter((selectedOption) => {
        return selectedOption.value !== item.value;
    });
}

export function selectItem(
    item: FilterOption,
    selectedOptions: FilterOption[]
): FilterOption[] {
    return [...selectedOptions, item];
}

export function handleSelect(
    item: FilterOption,
    selectedOptions: FilterOption[]
): FilterOption[] {
    if (isSelected(item, selectedOptions)) {
        return unSelectItem(item, selectedOptions);
    }
    return selectItem(item, selectedOptions);
}
